import React from 'react';
import { motion } from 'framer-motion';
import { SlideWrapper } from '../ui/SlideWrapper';
import { Fingerprint, Factory, Brain, Layers, Eye, Target } from 'lucide-react';
const reasons = [{
  icon: Fingerprint,
  title: 'Keine Standardsoftware',
  desc: 'Wir pressen Ihre Prozesse nicht in vorgefertigte Schablonen.'
}, {
  icon: Factory,
  title: 'Hohe Prozessnähe',
  desc: 'Wir verstehen die Sprache der Produktion und der Werkhalle.'
}, {
  icon: Eye,
  title: 'Volle Projekttransparenz',
  desc: 'Klare Kommunikation, nachvollziehbare Meilensteine und offene Zusammenarbeit.'
}, {
  icon: Target,
  title: 'Zielführende Entwicklung',
  desc: 'Fokus auf echten Mehrwert — keine unnötige Komplexität, sondern Ergebnisse.'
}, {
  icon: Brain,
  title: 'Technisches Verständnis',
  desc: 'Tiefe Expertise in Softwarearchitektur und modernen Technologien.'
}, {
  icon: Layers,
  title: 'Nachhaltige Lösungen',
  desc: 'Skalierbar, wartbar und bereit für zukünftige Anforderungen.'
}];
export function WhySlide() {
  return <SlideWrapper className="bg-bg-alt" data-id="element-247">
      <div className="h-full flex flex-col justify-center" data-id="element-248">
        <motion.div className="mb-10" data-id="element-249">
          <h2 className="text-5xl font-bold text-primary mb-4" data-id="element-250">
            Warum INTIGOO!
          </h2>
          <div className="h-1 w-24 bg-accent rounded-full" data-id="element-251" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-252">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2 + index * 0.1
        }} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start gap-5 hover:border-accent/50 transition-colors duration-300" data-id="element-253">
              <div className="w-12 h-12 bg-primary/5 rounded-xl flex items-center justify-center shrink-0 text-primary" data-id="element-254">
                <reason.icon className="w-6 h-6" data-id="element-255" />
              </div>
              <div data-id="element-256">
                <h3 className="text-lg font-bold text-primary mb-1" data-id="element-257">
                  {reason.title}
                </h3>
                <p className="text-text-secondary text-sm leading-relaxed" data-id="element-258">
                  {reason.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </SlideWrapper>;
}